import { FileStack, Search, CheckCircle2, Sparkles, Radio, ImageOff, FileWarning, PencilRuler } from "lucide-react";

const PIPELINE = [
  ["total_submitted", "Total Submitted", FileStack, "text-forest bg-sage/20"],
  ["under_review", "Under Review", Search, "text-earth bg-mustard/25"],
  ["approved", "Approved", CheckCircle2, "text-forest bg-sage/25"],
  ["showcased", "Showcased", Sparkles, "text-terracotta bg-terracotta/15"],
  ["live", "Live", Radio, "text-forest bg-sage/30"],
];

const ACTIONS = [
  ["images_required", "Images Required", ImageOff],
  ["information_required", "Information Required", FileWarning],
  ["changes_requested", "Changes Requested", PencilRuler],
];

export function BrandStatsBar({ stats }) {
  const s = stats || {};
  const actionTotal = (s.images_required || 0) + (s.information_required || 0) + (s.changes_requested || 0);
  return (
    <div className="space-y-3" data-testid="brand-stats-bar">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {PIPELINE.map(([k, label, Icon, accent]) => (
          <div key={k} className="bg-white rounded-2xl soft-shadow p-4" data-testid={`brand-stat-${k}`}>
            <div className={`w-9 h-9 rounded-lg flex items-center justify-center mb-2 ${accent}`}><Icon className="w-4.5 h-4.5" strokeWidth={1.75} /></div>
            <p className="text-2xl font-heading text-forest leading-none">{s[k] ?? 0}</p>
            <p className="text-xs text-brown/60 mt-1">{label}</p>
          </div>
        ))}
      </div>
      <div className="bg-white rounded-2xl soft-shadow p-4" data-testid="brand-action-required">
        <div className="flex items-center justify-between mb-3">
          <p className="text-sm font-500 text-forest">Action Required</p>
          {actionTotal > 0
            ? <span className="text-xs bg-terracotta/15 text-terracotta px-2 py-0.5 rounded-full" data-testid="brand-action-total">{actionTotal} item{actionTotal > 1 ? "s" : ""} need attention</span>
            : <span className="text-xs text-olive" data-testid="brand-action-total">All clear</span>}
        </div>
        <div className="grid grid-cols-3 gap-3">
          {ACTIONS.map(([k, label, Icon]) => (
            <div key={k} className="flex items-center gap-3 bg-sand rounded-xl px-3 py-2.5" data-testid={`brand-action-${k}`}>
              <Icon className="w-4.5 h-4.5 text-earth shrink-0" strokeWidth={1.75} />
              <div className="min-w-0"><p className="text-xl font-heading text-forest leading-none">{s[k] ?? 0}</p><p className="text-[11px] text-brown/60 mt-0.5 truncate">{label}</p></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
